'use strict';

import ErrorView from 'standard-vote/app/scripts/views/error.js';

module.exports = ErrorView;



// WEBPACK FOOTER //
// ./app/scripts/views/error.js